<template>
  <div>
    <com-dialog :visible.sync="visible" width="50%" title="审核">
      <el-descriptions title="提现信息" :column="2">
        <el-descriptions-item label="订单编号">{{ info.number }}</el-descriptions-item>
        <el-descriptions-item label="提现金额">{{ info.amount }}</el-descriptions-item>
        <el-descriptions-item label="应到账金额">{{ info.reviceSum }}</el-descriptions-item>
        <el-descriptions-item label="已退款金额">{{ info.successRefundPrice }}</el-descriptions-item>
        <el-descriptions-item label="剩余待退款金额">{{ info.surplusRefundPrice }}</el-descriptions-item>
        <el-descriptions-item label="退款进度">{{ info.refundProgressText }}</el-descriptions-item>
        <el-descriptions-item label="提现时间">{{ info.createTime | timeFormate }}</el-descriptions-item>
        <el-descriptions-item label="申请前充值金额">{{ info.beforeChargeSum }}</el-descriptions-item>
        <el-descriptions-item label="申请前赠送金额">{{ info.beforeGiveSum }}</el-descriptions-item>
        <el-descriptions-item label="审核时间" v-if="info.auditTime">{{ info.auditTime | timeFormate }}</el-descriptions-item>
        <el-descriptions-item label="操作人" v-if="info.auditTime">{{ info.refOperatorName }}</el-descriptions-item>
        <!-- <el-descriptions-item label="冻结充值金">{{ info.userFreeze }}</el-descriptions-item>
        <el-descriptions-item label="冻结赠送金">{{ info.userFreezeGiveSum }}</el-descriptions-item> -->
      </el-descriptions>
      <div class="mt-15px">
        <el-descriptions title="用户" :column="3">
          <el-descriptions-item label="用户ID">{{ info.refUserNumber }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ info.refUserPhone }}</el-descriptions-item>
          <el-descriptions-item label="网点">{{ info.refUserRegisterStoreName }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="mt-15px">
        <el-descriptions title="审核状态" :column="1">
          <el-descriptions-item label="审核状态">{{ auditStatus[info.auditStatus] }}</el-descriptions-item>
          <el-descriptions-item label="拒绝原因" v-if="info.auditStatus === 2">{{ info.refuseReason }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="flex items-center justify-end">
        <el-button type="" @click="close">取消</el-button>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      form: {},
      type: null,
      info: {},
      auditStatus: {
        0: '待审核',
        1: '通过',
        2: '不通过'
      },
    }
  },
  methods: {
    open(opt) {
      const { row } = opt
      this.info = utils.deepCopy(row)
      
      console.log('userWithdrawCodeList :>> ', this.type, this.userWithdrawCodeList)
      this.visible = true
    },
    close() {
      this.visible = false
    },
  },
}
</script>
<style lang="scss">
.show_image {
  object-fit: contain;
  width: 150px;
  height: 150px;
}
</style>
